// extracted by mini-css-extract-plugin
module.exports = {"tableImg":"capture-log_tableImg_1Lwoh"};